function e(r, n) {
  return function(t) {
    return r(n(t));
  };
}
export {
  e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_overArg.js
// module id = 921
// module chunks = 67